export default __webpack_public_path__ + "static/media/ic_home.4d77d0ae.svg";